var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D1EDDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12V30H21V26.5H23V30H29V12H15ZM17 14H19V16H17V14ZM21 14H23V16H21V14ZM25 14H27V16H25V14ZM17 18H19V20H17V18ZM21 18H23V20H21V18ZM25 18H27V20H25V18ZM17 22H19V24H17V22ZM21 22H23V24H21V22ZM25 22H27V24H25V22ZM17 26H19V28H17V26ZM25 26H27V28H25V26Z",
    fill: "#2A8981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCompany);
export default __webpack_public_path__ + "static/media/activeCompany.fbc09e7bf8d8034e118f71769d9457f8.svg";
export { ForwardRef as ReactComponent };